import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { SharedModule } from '@ddt-web/common';
import { DomModule } from '@ddt-web/dom';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';

import { PaginationModule } from '../pagination';
import { TableCellModule } from '../table-cell';
import { StickyTableIEComponent } from './ie/sticky-table-ie.component';
import { StickyTableComponent } from './sticky-table.component';

@NgModule({
	declarations: [StickyTableComponent, StickyTableIEComponent],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		SharedModule,
		CwpNgFrameworkModule,
		CdkTableModule,
		PaginationModule,
		TableCellModule,
		GenericDirectivesModule,
		DomModule
	],
	exports: [StickyTableComponent, StickyTableIEComponent]
})
export class StickyTableModule { }
